import 'virtual:polyfills';
import React from 'react';
import { createRoot } from 'react-dom/client';
import 'wicg-inert';
import { registerSW } from 'virtual:pwa-register';
import { configureEnv } from '@debatdirect/common/src/env';
import { setDefaultOptions as setDateFnsDefaultOptions } from 'date-fns';
import { nl } from 'date-fns/locale';

import { register } from '#src/modules/register';
import { initSentry } from '#src/sentry';
import { bootstrapLegacy } from '#src/utils/bootstrap-legacy';
import { injectCastSender, injectPlayer, injectStats } from '#src/utils/di';

import '#src/styles/main.scss';

// Collect env vars
configureEnv({
  APP_VERSION: import.meta.env.APP_VERSION,
  APP_BASE_URL: import.meta.env.APP_BASE_URL,
  APP_API_BASE_URL: import.meta.env.APP_API_BASE_URL,
  APP_CDN_BASE_URL: import.meta.env.APP_CDN_BASE_URL,
  APP_SOCKET_URL: import.meta.env.APP_LIVE_URL,
  APP_ELASTIC_URL: import.meta.env.APP_ELASTIC_URL,
  APP_STATIC_URL: import.meta.env.APP_STATIC_URL,
  APP_STREAM_SHARE_URL: import.meta.env.APP_STREAM_SHARE_URL,
  DEV: import.meta.env.DEV,
});

injectPlayer();
injectStats();
injectCastSender();

async function run() {
  await register();

  // bootstrap legacy code (global state)
  await bootstrapLegacy();

  // initialize Sentry to have early error tracking
  await initSentry();

  setDateFnsDefaultOptions({ locale: nl });

  const { default: App } = await import('./App');
  const rootElement = document.getElementById('root');

  if (rootElement) {
    const root = createRoot(rootElement);
    root.render(<App />);
  } else {
    console.info('Application - rootElement not found');
  }
}

run();

const refresh = registerSW({
  immediate: true,
  onNeedRefresh: () => refresh(true),
});
